export enum EQueryKeys {
  AbUse__V1_GetMultipleExperiment = 'ab-use__/v1/get-multiple-experiment/',
  Favorites__V1_AddFavorite = 'favorites__/v1/add-favorite/',
  Favorites__V1_DeleteOfferFromFavorites = 'favorites__/v1/delete-offer-from-favorites/',
  HiddenObjects__V1_HideOfferWebsite = 'hidden-objects__/v1/hide-offer-website/',
  FrontendFooter__V1_GetFooterMarkup = 'frontend-footer__/v1/get-footer-markup/',
  HeaderFrontend__V1_GetHeaderMarkup = 'header-frontend__/v1/get-header-markup/',
  MonolithPython__CianApi_Site_V1_GetUserDataByRequest = 'monolith-python__/cian-api/site/v1/get-user-data-by-request/',
  SearchOffersIndex__V1_GetJsonQueryByPath = 'search-offers-index__/v1/get-json-query-by-path/',
  YandexMap__V2_1_GetYandexMap = 'yandex-map__/v2.1/get-yandex-map/',
  ModerationComplainFrontend__V1_GetModerationComplainMicrofrontend = 'moderation-complain-frontend__/v1/get-moderation-complain-microfrontend/',
  SearchOffersIndex__V2_MapGetBbox = 'search-offers-index__/v2/map/get-bbox',
  SearchOffersIndex__V2_GetClustersForMap = 'search-offers-index__/v2/get-clusters-for-map/',
  SearchOffers__V1_GetOffersByPin = 'search-offers__/v1/get-offers-by-pin/',
  SearchOffers__V2_GetInfiniteSearchResultDesktop = 'search-offers__/v2/get-infinite-search-result-desktop/',
  SearchOffers__V3_SearchOffersDesktop = 'search-offers__/v3/search-offers-desktop/',
  Comparison__V1_AddToComparison = 'comparison__/v1/add-to-comparison/',
  Comparison__V1_DeleteFromComparison = 'comparison__/v1/delete-from-comparison/',
  AdBanner__V1_GetBannerEnrichments = 'ad-banner__/v1/get-banner-enrichments/',
}
